<template>
    <div class="partner-area ptb-100">
        <div class="container">
            <div class="partner-wrap">
                <carousel
                    :autoplay="5000"
                    :settings='settings' 
                    :breakpoints='breakpoints'
                >
                    <slide v-for="slide in carouselItems" :key="slide.id">
                        <div class="partner-item">
                            <img :src="slide.image" alt="Image">
                            <div class="partner-overly">
                                <img :src="slide.imageOverly" alt="Image">
                            </div>
                        </div>
                    </slide>
                    
                    <template #addons>
                    </template>
                </carousel>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { Carousel, Slide  } from 'vue3-carousel';

import 'vue3-carousel/dist/carousel.css';

export default defineComponent ({
    name: 'Partner',
    components: {
        Carousel,
        Slide,
    },
    data: () => ({
        settings: {
            itemsToShow: 1,
            snapAlign: 'center',
        },
        carouselItems: [
            {
                id: 1,
                image: require('../../assets/images/partner/partner-1.png'),
                imageOverly: require('../../assets/images/partner/partner-6.png'),
            },
            {
                id: 2,
                image: require('../../assets/images/partner/partner-2.png'),
                imageOverly: require('../../assets/images/partner/partner-7.png'),
            },
            {
                id: 3,
                image: require('../../assets/images/partner/partner-3.png'),
                imageOverly: require('../../assets/images/partner/partner-8.png'),
            },
            {
                id: 4,
                image: require('../../assets/images/partner/partner-4.png'),
                imageOverly: require('../../assets/images/partner/partner-9.png'),
            },
            {
                id: 5,
                image: require('../../assets/images/partner/partner-5.png'),
                imageOverly: require('../../assets/images/partner/partner-10.png'),
            },
            {
                id: 6,
                image: require('../../assets/images/partner/partner-1.png'),
                imageOverly: require('../../assets/images/partner/partner-6.png'),
            },
            {
                id: 7,
                image: require('../../assets/images/partner/partner-2.png'),
                imageOverly: require('../../assets/images/partner/partner-7.png'),
            },
            {
                id: 8,
                image: require('../../assets/images/partner/partner-3.png'),
                imageOverly: require('../../assets/images/partner/partner-8.png'),
            },
            {
                id: 9,
                image: require('../../assets/images/partner/partner-4.png'),
                imageOverly: require('../../assets/images/partner/partner-9.png'),
            },
        ],
        breakpoints: {
            0: {
                itemsToShow: 2,
                snapAlign: 'left',
			},
            576: {
                itemsToShow: 3,
                snapAlign: 'center',
            },
            768: {
                itemsToShow: 4,
                snapAlign: 'center',
            },
            1024: {
                itemsToShow: 4,
                snapAlign: 'center',
            },
            1200: {
                itemsToShow: 5,
                snapAlign: 'center',
            },
        },
    }),
})
</script>